// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Composer_wrapper__2LtqP","innerWrapper":"Composer_innerWrapper__1kkZ2","input":"Composer_input__3NazB"};